import Vue from 'vue'

const mutations = {
    setPois(state, pois) {
        state.pois = [...pois]
    },
    setPoisLoaded(state, loaded) {
        state.poisLoaded = loaded
    },
    setPoisLoading(state, loading) {
        state.poisLoading = loading
    },
    setPoiAddresses(state, addresses) {
        if (!Array.isArray(addresses) || addresses.length === 0) return

        const addressesById = new Map(addresses.map((entry) => [entry.id, entry]))
        state.pois.forEach((poi) => {
            const entry = addressesById.get(poi.id)
            if (!entry) return

            // Do not apply an address resolved for coordinates that changed meanwhile.
            if (String(poi.lat) !== String(entry.lat) || String(poi.lng) !== String(entry.lng)) {
                return
            }

            Vue.set(poi, 'address', entry.address)
            Vue.set(poi, 'address_cached_at', entry.cachedAt)
        })
    },
    setPoiCategories(state, categories) {
        state.poiCategories = [...categories]
    },
    addPoi(state, poi) {
        state.pois = [...state.pois, poi]
    },
    updatePoi(state, poi) {
        const index = state.pois.findIndex((p) => p.id === poi.id)
        if (index !== -1) {
            state.pois = [...state.pois.slice(0, index), { ...poi }, ...state.pois.slice(index + 1)]
        }
    },
    focusPoi(state, poi) {
        const previousIndex = state.pois.findIndex((item) => item.on_focus)
        const nextIndex = state.pois.findIndex((item) => item.id === poi.id)

        if (previousIndex === nextIndex) return

        const pois = [...state.pois]
        if (previousIndex !== -1) {
            pois[previousIndex] = { ...pois[previousIndex], on_focus: false }
        }
        if (nextIndex !== -1) {
            pois[nextIndex] = { ...pois[nextIndex], on_focus: true }
        }
        state.pois = pois
    },
    removePoi(state, poi) {
        state.pois = state.pois.filter((p) => p.id !== poi.id)
    },
    setPoisNotifications(state, notifications) {
        const list = Array.isArray(notifications) ? notifications : []
        state.poisNotifications = list.reduce((acc, notification) => {
            acc[notification.poi_id] = notification
            return acc
        }, {})
    },
    addPoiNotification(state, notification) {
        state.poisNotifications[notification.poi_id || notification.poiId] = notification
    },
    removePoiNotification(state, poi_id) {
        delete state.poisNotifications[poi_id]
    }
}

export default mutations
